import 'vite/modulepreload-polyfill';
import '@hotwired/turbo-rails';
import { start } from '@nerdgeschoss/shimmer';
import { application } from './controllers/application';
import './controllers';
import './lib/jsbridge';

start({ application });
